import { DocStep } from '../types';

const isOnboardingStep = (step: DocStep) => step.kind.startsWith('PRE_EMPLOYMENT') || step.kind === 'BANK_ACCOUNT';

const filterRequestedSteps = (steps: DocStep[]): DocStep[] => {
  const requested = steps.filter((step) => !isOnboardingStep(step));
  const hasRequestedDocument = requested.some((step) => step.kind !== 'REVIEW');

  return hasRequestedDocument ? requested : steps;
};

export default filterRequestedSteps;
